import React, {useEffect, useState} from 'react'
import {searchService} from 'services'
import requestHandler from 'utils/requestHandler'
import ProductsList from 'components/ProductsList'
import getPageSize from 'utils/getPageSize'

const pageSize = getPageSize()

const Category = ({match: {params: {alias}}}) => {
  const [data, setData] = useState(undefined)

  useEffect(() => {
    requestHandler(() => searchService.categoryProducts(alias), 'json')
      .then(r => {
        if (r.success) setData(r.data)
        else setData(null)
      })
  }, [alias])

  return (
    <div className='categoryProducts'>
      {data ? (
        <ProductsList
          mode='categoryItems'
          items={data.items}
          loadMoreRequest={(page) => searchService.categoryProducts(alias, '', {take: pageSize, skip: page * pageSize})}
          setData={setData}
          searchValue={'Placeholder category title'}
        />
      ) : data === undefined ? (
        'loading...'
      ) : (
        'error'
      )}
    </div>
  )
}

export default Category
